module.exports = __webpack_public_path__ + "img/mechanical-arm-icon.ed33a430.svg";